import * as fromReports from '../reducers/reports.reducer';
import { State } from '../reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getReports = createFeatureSelector<State, fromReports.State>('reports');

export const getReportList = createSelector(getReports, (state) => state.list);
export const getReportById = (id) => createSelector(getReports, (state) => state.list?.find((r) => r.report_id === id));
